import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import router from './router/index';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/base.css'
Vue.config.productionTip = false
Vue.use(ElementUI); 
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
